import apiInstance from "../Api/ApiInstance";

export async function Citys() {
  return await apiInstance.get(`api/nexus-main/citys/`);
}
